module.exports = __webpack_public_path__ + "img/symmetry_jp.5c68efd.jpg";